import { GetFullUserType } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useUploadProfilePicture = () => {
    const queryClient = useQueryClient()

    return useMutation<GetFullUserType, Error, File>({
        mutationFn: async (file: File) => {
            const formData = new FormData()
            formData.append('file', file)
            const response = await api.post<GetFullUserType>('/users/profile-picture', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            })
            return response.data
        },
        onSuccess: (data) => {
            queryClient.setQueryData(queryKeys.me(), data)
        },
    })
}
